import styles from "../styles/SmileTrips.css";
import { useState, useEffect } from "react";
import Header from "../Components/Header";
import { Button, Typography, Box, IconButton, Modal, Grid2 } from "@mui/material";
import axios from "axios";
import Footer from "../Components/Footer";
import Agendar from "../Components/Agendar";



const SmileTrips = () => {
    const [servicos, setServicos] = useState([]);
    const [selectedServico, setSelectedServico] = useState(null);
    const [equipe, setEquipe] = useState([])
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        descricao: "",
        text: "",
        foto: "",
        ordem: "",
      });

      useEffect(() => {
        axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-smileTrips`)
          .then((response) => {
            const data = response.data;
            setServicos(data);
      
           
            if (data.length > 0) {
              setSelectedServico(data[0]);
              handleSelectServico(data[0]); 
            }
          })
          .catch((error) => {
            console.error('Erro na requisição:', error);
          });
      }, []); 


      const handleSelectServico = (servico) => {
        setSelectedServico(servico);
      
        axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-servicos?name=${servico.name}`)
          .then((response) => {
            const data = response.data;
      
            if (data.profissional) {
              data.profissional.sort((a, b) =>
                a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' })
              );
            }
      
            setEquipe(data.profissional || []);
          })
          .catch((error) => {
            console.error('Erro na requisição:', error);
          });
      };

    return(
        <div className="container">
            <Header/>
            <div className="content">             
                <div className="smileTripsContainer">
                    <div className="smileTripsContent">
                        <div className="subTitle from-top">Internacional</div>
                        <div className="title depo from-top">Smile Trips</div>
                        <div className="titleLine from-top"/>
                        <div className="textSmileTrips from-top">O <strong>Smile Trips</strong> é um programa exclusivo criado para pacientes <strong>internacionais</strong> que desejam realizar seus tratamentos odontológicos na <strong>Odonto Luzzi</strong> com conforto, segurança e excelência.
                        Aqui, reunimos nossas principais especialidades em um fluxo simples e organizado, para que você entenda cada etapa do tratamento antes mesmo de viajar.</div>
                        <div className="smileTripsList">
                            <div className="smileTripsMenu from-left">
                                {servicos.map((servico) => (
                                    <div className="smileTripsServico" onClick={() => handleSelectServico(servico)}>
                                        <div className="smileTripsMenuTitle" style={selectedServico?.id === servico.id ? { color: '#fff' } : {}}>{servico.name}</div>
                                        <div className="titleLine" style={{width:'100%', backgroundColor: selectedServico?.id === servico.id ? '#FFF' : '#B08E44', marginTop:5, marginBottom:10}}/>
                                    </div>
                                ))}   
                            </div>
                            <div className="smileTripsInt from-right">
                                
                                <div className="smileTripsName from-right">{selectedServico?.name}</div>
                                {selectedServico?.foto ? <img className="smileTripsFoto from-right" style={{ transitionDelay: '0.1s' }} src={`https://api.sigmasystems.com.br/api/odontoluzzi/uploads/especialidades/${selectedServico.foto}`}/> : <img className="smileTripsFoto from-right" style={{ transitionDelay: '0.1s' }} src={"https://odontoluzzi.com.br/images/padrao/padraoServico.png"}/>}
                                
                                <div className="smileTripsText from-right" style={{ transitionDelay: '0.2s' }}>{selectedServico?.text}</div>
                                {equipe.length > 0 ? <div className="intTitle2">Profissionais</div> : ''}
                                <Grid2 className='from-bottom' columns={{ xs:4, sm:8, md:12}} container spacing={2} justifyContent={'left'} marginBottom='70px'>
                                    <Grid2 item>
                                        <Grid2 container justifyContent={'left'} spacing={3} width={'100%'} marginLeft={0}>
                                            {equipe.map((prof, index) => (
                                                <div className="equipeCard"  key={index}>
                                                    {prof?.foto ? <img className="equipeFoto" src={`https://api.sigmasystems.com.br/api/odontoluzzi/uploads/equipe/${prof.foto}`}/> : <img className="equipeFoto" src={"https://odontoluzzi.com.br/images/padrao/padraoEquipe.png"}/>}
                                                    <div className="equipeName">Dr {prof?.name || ''}</div>
                                                    <div className="equipeTitle">{prof?.titulo}</div>
                                                    <div className="equipeCro">CRO-{prof?.cro_uf} {prof?.cro}</div>
                                                </div>
                                            ))}    
                                        </Grid2>                    
                                    </Grid2>
                                </Grid2>
                            </div>
                        </div>      
                    </div>
                </div>
            </div>
            <Agendar/>
            <Footer/>
        </div>
    )
}
export default SmileTrips;